import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { VoucherV2WithAttachmentContainerModel } from '../../../../../../models/aggregates/erp/coupon';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa, Pagination } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VoucherV2WithAttachmentService extends BaseApiPublicLoginTemplateService<VoucherV2WithAttachmentContainerModel, VoucherV2WithAttachmentContainerModel, VoucherV2WithAttachmentContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/login-ep';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/login-entity-ep';
    this.httpClient = http;
  }

  getVouchersByEntityGuid(visa: ApiVisa): Observable<ApiResponseModel<VoucherV2WithAttachmentContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/valid-by-login-subject/login-entity-ep';
    let url = Core2Config.DOMAIN_URL + endpoint_path;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<VoucherV2WithAttachmentContainerModel>>(url, this.getHttpHeader(visa));
  }

  getVouchersByWebsiteHdrGuid(websiteHdrGuid: string, visa: ApiVisa): Observable<ApiResponseModel<VoucherV2WithAttachmentContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/website-link/login-ep/' + websiteHdrGuid;
    let url = Core2Config.DOMAIN_URL + endpoint_path;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<VoucherV2WithAttachmentContainerModel>>(url, this.getHttpHeader(visa));
  }

  getVouchersByCriteria(pagination: Pagination, visa: ApiVisa): Observable<ApiResponseModel<VoucherV2WithAttachmentContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/snapshot/login-ep/query?' + pagination.getQueryKeyValues();
    let url = Core2Config.DOMAIN_URL + endpoint_path;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<VoucherV2WithAttachmentContainerModel>>(url, this.getHttpHeader(visa));
  }

  getAlreadyClaimedVouchersByEntityGuid(visa: ApiVisa): Observable<ApiResponseModel<VoucherV2WithAttachmentContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/already-claimed-vouchers/login-entity-ep';
    let url = Core2Config.DOMAIN_URL + endpoint_path;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<VoucherV2WithAttachmentContainerModel>>(url, this.getHttpHeader(visa));
  }
}
